<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="generatePayrollModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Generate Payroll</small
                >
              </legend>
              <form @submit.prevent="generatePayroll()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Month</label>
                      <select
                        name="month"
                        class="form-control month"
                        required
                      >
                        <option value>select month</option>
                        <option value="Jan">January</option>
                        <option value="Feb">February</option>
                        <option value="Mar">March</option>
                        <option value="Apr">April</option>
                        <option value="May">May</option>
                        <option value="Jun">June</option>
                        <option value="Jul">July</option>
                        <option value="Aug">August</option>
                        <option value="Sep">September</option>
                        <option value="Oct">October</option>
                        <option value="Nov">November</option>
                        <option value="Dec">December</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Month</label>
                      <select
                        name="year"
                        class="form-control year"
                        required
                      >
                        <option value>select year</option>
                        <option value="2023">2023</option>
                        <option value="2024">2024</option>
                        <option value="2025">2025</option>
                        <option value="2026">2026</option>
                        <option value="2027">2027</option>
                        <option value="2028">2028</option>
                        <option value="2029">2029</option>
                        <option value="2031">2030</option>
                        <option value="Sep">2031</option>
                        <option value="2032">2032</option>
                        <option value="2033">2033</option>
                        <option value="2034">2034</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingPayroll"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingPayrollLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small class="font-size:15px; font-weight: bold"
          >manage employees</small
        >
      </legend>
      <button
        type="button"
        class="btn btn-success btn-roundec"
        data-toggle="modal"
        data-target="#generatePayrollModal"
      >
        <i class="fa fa-file-pdf-o"></i> Employee Payroll
      </button>
      <p></p>
      <div></div>
      <div>
        <div class="employeesLoader">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <i
            class="fa fa-spinner fa-spin"
            style="font-size: 24px; color: blue"
          ></i>
          loading employees...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemEmployees"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'rows per page',
            ofLabel: 'of',
            pageLabel: 'page', //for 'pages' mode
            allLabel: 'all',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Edit'">
              <button
                class="btn btn-info btn-sm btn-block"
                @click="viewEmployee(props.row.id)"
              >
                <i class="fa fa-edit"></i> Edit employee
              </button>
            </span>
            <span v-else-if="props.column.field == 'Deductions'">
              <span v-if="props.row.occupation_id != 2">
                <button
                  class="btn btn-primary btn-sm"
                  @click="loadDeductions(props.row.id)"
                >
                  <i class="fa fa-money"></i> Employee Deductions
                </button>
              </span>
              <span v-else>
                <button class="btn btn-primary btn-sm">
                  <i class="fa fa-money"></i> Driver Deductions
                </button>
              </span>
            </span>
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Employee no",
          field: "employee_no",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter emp number",
          },
        },
        {
          label: "Employee name",
          field: "employee_name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter emp number",
          },
        },
        {
          label: "Id no",
          field: "id_no",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter emp number",
          },
        },
        {
          label: "Phone no",
          field: "phone_no",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter emp number",
          },
        },
        {
          label: "Occupation",
          field: "occupation_name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter emp number",
          },
        },
        {
          label: "Edit",
          field: "Edit",
          width: "40px",
          html: true,
        },
        {
          label: "Deductions",
          field: "Deductions",
          width: "40px",
          html: true,
        },
      ],
    };
  },
  created() {
    this.loadEmployees();
  },
  computed: {
    ...mapGetters(["systemEmployees"]),
  },
  methods: {
    ...mapActions([
      "loadEmployees",
      "viewEmployee",
      "leaveApplication",
      "advanceApllication",
      "checkIn",
      "loadDeductions",
      "generatePayroll",
    ]),
  },
};
</script>
<style scoped>
.creatingAttendanceLoader {
  display: none;
}
.creatingPayrollLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/employees/manageemployees.vue